"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactDom = require("react-dom");
var _reactRedux = require("react-redux");
var _dom = _interopRequireDefault(require("@spothero/utils/dom"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
class RenderInBody extends _react.Component {
  componentDidMount() {
    const {
      className
    } = this.props;
    this._container = document.createElement('div');
    this._root = (0, _reactDom.createRoot)(this._container);
    if (className) {
      _dom.default.addClass(this._container, className);
    }
    document.body.appendChild(this._container);
    this._renderLayer();
  }
  componentDidUpdate(prevProps, prevState) {
    this._renderLayer();
  }
  componentWillUnmount() {
    this._root.unmount();
    document.body.removeChild(this._container);
  }
  _renderLayer() {
    const {
      store,
      children
    } = this.props;
    if (store) {
      this._root.render(/*#__PURE__*/_react.default.createElement(_reactRedux.Provider, {
        store: store
      }, children));
    } else {
      this._root.render(children);
    }
  }
  render() {
    return null;
  }
}
exports.default = RenderInBody;